var $document = $(document);

$document.ajaxSend(function(event, jqXHR) {
  jqXHR.setRequestHeader('X-Xsrf-Token',  $.cookie('csrf_cookie_name'));
  jqXHR.setRequestHeader('X-Requested-With',  'XMLHttpRequest');
});

//Register global handler in case an ajax call is made when the user is logged out.
$document.ajaxSuccess(function(event, request) {
  if (request.getResponseHeader('Refresh') !== null) {
    var refresh = request.getResponseHeader('Refresh');
    var url = refresh.substr(refresh.indexOf('url=') + 4);
    if (url.length > 0) {
      document.location = url;
    }
  }
});
